/* eslint-disable no-undef */
export function getRealVideoWidth(config) {
  return document.getElementById(config.targetContentId)?.querySelector('#video-player-container')
    ?.clientWidth;
}

export function getRealVideoHeight(config) {
  return document.getElementById(config.targetContentId)?.querySelector('#video-player-container')
    ?.clientHeight;
}
